// extracted by mini-css-extract-plugin
export default {"dividerBox":"StripeExpressCheckoutSection_dividerBox__20oZE"};